export default ({ request }) => ({
  pendingPlanOrderListApi(data = {}) {
    return request({
      url: '/factory/pending/plan/order/info/list',
      method: 'post',
      data,
    })
  },
})
